import { isPhysicsAuthoringLocked } from "../../utils/physicsGuards";
import { logger } from "../../utils/logger";
import { showBrowserImportLimitIssue, userMessageForImportError } from "../../utils/importLimits";

const showImportWarning = (message) => {
  window.dispatchEvent(new CustomEvent("critter-toast", { detail: { message } }));
};

export default function MainPanelHiddenFileInputs({ onFilesSelected, onEnvironmentSelected }) {
  return (
    <>
      <input
        id="file-upload"
        type="file"
        multiple
        accept=".xml,.urdf,.xacro,.obj,.stl,.dae,.glb,.gltf,.mtl,.png,.jpg,.jpeg"
        onChange={(event) => {
          if (isPhysicsAuthoringLocked()) {
            event.target.value = "";
            return;
          }
          onFilesSelected(event);
        }}
        className="hidden"
      />
      <input
        id="folder-upload"
        type="file"
        multiple
        webkitdirectory=""
        onChange={(event) => {
          if (isPhysicsAuthoringLocked()) {
            event.target.value = "";
            return;
          }
          onFilesSelected(event);
        }}
        className="hidden"
      />
      <input
        id="environment-load"
        type="file"
        accept=".critter,.critterrefs,.zip"
        onChange={async (event) => {
          const file = event.target.files?.[0] || null;
          event.target.value = "";
          if (!file) return;
          if (isPhysicsAuthoringLocked()) return;
          try {
            await onEnvironmentSelected(file);
          } catch (error) {
            logger.error("[main] Failed to load Critter project:", error);
            if (showBrowserImportLimitIssue(error)) return;
            showImportWarning(
              userMessageForImportError(
                error,
                "Critter project could not be imported. Check the console for details."
              )
            );
          }
        }}
        className="hidden"
      />
    </>
  );
}
